//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import firebase from 'firebase/app'
import 'firebase/firestore'
import * as api from '@/api/api'
export default {
    data() {
        return {
            src: '',
            splash: true,
            data: '',
            loading: true,
            render: false,
            restaurant: '',
            decorations: {
                angel: {
                    splashButtonColor: '#000000',
                    splashColor: '#ffffff',
                    logo: 'Angel.jpeg',
                    menuBackgroundColor: '#f7f7f7',
                    textColor: '#000000',
                    spinerColor: 'black',
                },
                demo: {
                    splashButtonColor: '#f56c12',
                    splashColor: '#217b95',
                    logo: 'demo.jpeg',
                    menuBackgroundColor: '#c9c9c9',
                    textColor: '#ffffff',
                    spinerColor: 'white',
                },
                panamaHotDog: {
                    splashButtonColor: '#000000',
                    splashColor: '#ffffff',
                    logo: 'pmahtdg_logo.png',
                    menuBackgroundColor: '#f7f7f7',
                    textColor: '#000000',
                    spinerColor: 'black',
                },
            },
        }
    },
    methods: {
        closeSplash() {
            this.splash = false
            setTimeout(function () {
                // document.documentElement.requestFullscreen()
            }, 300)
        },
    },
    async mounted() {
        this.render = false
        let path = await this.$route.path.replace('/', '')
        this.restaurant = path
        this.render = true
        this.$analytics.logEvent('Menu Enter', {
            path: `${this.$route.params.path}`,
        })
        this.loading = true
        api.returRestaurantActiveMenu({path: path})
            .then(response => {
                this.data = response.data.data
            })
            .then(() => {
                this.loading = false
            })
    },
}
